module.exports = __webpack_public_path__ + "images/Ubuntu-Regular_1c5965c2b1dcdea439b54c3ac60cee38.ttf";